/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_0Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_2_bullets_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organize tabular data: keep one kind of value in each column and one record on each row. A clear header row makes sorting, filtering and reviewing much easier.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_2_bullets_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织表格数据：每列存放同一类内容，每行对应一条记录。明确的表头会让排序、筛选和检查更容易。`)
};

/**
* | output |
* | --- |
* | "Organize tabular data: keep one kind of value in each column and one record on each row. A clear header row makes sorting, filtering and reviewing much easier." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_2_bullets_0 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_2_bullets_0(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_2_bullets_0(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_2_bullets_0 as "gc.search_guides.what_is_gridcraft.sections.2.bullets.0" }